import React from 'react';
import { FaRobot, FaUser } from 'react-icons/fa';
import Olympic_ViewQuestions from 'pages/Olympic/ViewQuestions';
import Olympic_Admin from 'pages/Olympic/Admin';
import Users from 'pages/Administration/Users';
import OneChoice_Update from 'modules/OlympicSGKModule/components/OneChoice/Update';
import ViewQuestions from 'modules/Olympic/components/ViewQuestions';
import PronunciationAssessment from 'pages/Administration/SpeechToText';
import { administrators } from 'constants/auth';

export default [
  // {
  //   path: '/admin/users',
  //   name: 'Quản lý người dùng',
  //   miniName: 'C',
  //   icon: 'ni ni-ungroup',
  //   component: Users,
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['administrator'],
  //   users: administrators,
  //   showInSidebar: true,
  //   sortOrder: 0,
  // },
  // {
  //   path: '/admin/classes',
  //   name: 'Quản lý lớp học',
  //   miniName: 'C',
  //   icon: 'ni ni-ungroup',
  //   component: React.lazy(() => import('pages/Administration/Classes')),
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['administrator'],
  //   users: administrators,
  //   showInSidebar: true,
  //   sortOrder: 0,
  // },
  // {
  //   path: '/admin/quiz',
  //   name: 'Quiz',
  //   miniName: 'Q',
  //   icon: 'ni ni-ungroup',
  //   component: OneChoice_Update,
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['administrator'],
  //   users: administrators,
  //   showInSidebar: true,
  //   sortOrder: 0,
  // },
  // {
  //   collapse: true,
  //   name: 'Olympic (Admin)',
  //   icon: <FaUser className='tw-text-purple-600' size={16} />,
  //   roles: ['administrator'],
  //   users: administrators,
  //   showInSidebar: true,
  //   sortOrder: 0,
  //   state: 'olympic/admin',
  //   views: [
  //     {
  //       path: '/olympic/admin/questions/class/:ClassName/types/:type',
  //       component: ViewQuestions,
  //       layout: '/lms',
  //       exact: true,
  //       roles: ['administrator'],
  //       users: administrators,
  //     },
  //     {
  //       path: '/olympic/admin/questions/class/',
  //       name: 'Question types (All)',
  //       miniName: 'T',
  //       component: Olympic_ViewQuestions,
  //       layout: '/lms',
  //       exact: true,
  //       roles: ['administrator'],
  //       users: administrators,
  //       showInSidebar: true,
  //       sortOrder: 0,
  //     },
  //     {
  //       path: '/olympic/admin',
  //       name: 'Question types (Class)',
  //       miniName: 'O',
  //       component: Olympic_Admin,
  //       layout: '/lms',
  //       exact: false,
  //       roles: ['administrator'],
  //       users: administrators,
  //       showInSidebar: true,
  //       sortOrder: 0,
  //     },
  //   ],
  // },
  // {
  //   path: '/ai/pronunciation-assessment',
  //   name: 'Pronunciation assessment',
  //   miniName: 'P',
  //   icon: <FaRobot className='tw-text-yellow-600' size={16} />,
  //   component: PronunciationAssessment,
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['administrator'],
  //   users: administrators,
  //   showInSidebar: true,
  //   sortOrder: 0,
  // },
];
